export default {"src":"/_next/static/media/essentials.e5fda562.svg","height":100,"width":100};